import {Component, inject, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {IbpUiBlockerService} from "../../../../ibp-services/third-party/ibp-prime-ng/ibp-ui-blocker.service";
import {Observable} from "rxjs";
import { CommonModule } from '@angular/common';
import { BlockUI } from 'primeng/blockui';

@Component({selector: 'ibp-blocking-overlay',
  templateUrl: './ibp-blocking-overlay.component.html',
  styleUrls: ['./ibp-blocking-overlay.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule,
    BlockUI,],
})
export class IbpBlockingOverlayComponent implements OnInit {

  private uiBlocker = inject(IbpUiBlockerService);

  @Input()
  public target?: any;

  public blocked$: Observable<boolean>;

  public ngOnInit(): void {
    this.blocked$ = this.uiBlocker.blocked$;
  }
}
